import { createStore } from '@stencil/store';

export interface ExternalUserData {
  id: string;
  name: string;
  email?: string;
  document?: string;
  accountId?: string;
}

interface ExternalUserState {
  externalUserData?: ExternalUserData;
}

const { state } = createStore<ExternalUserState>({
  externalUserData: undefined,
});

export function setExternalUserData(externalUserData: ExternalUserData): void {
  state.externalUserData = externalUserData;
}

export function clearExternalUserData(): void {
  state.externalUserData = undefined;
}

export function getExternalUserData(): ExternalUserData | undefined {
  return state.externalUserData;
}

export function getExternalUserHeaders(): Record<string, string> {
  const externalUserData = state.externalUserData;

  if (!externalUserData) {
    return {};
  }

  const headers: Record<string, string> = {
    'X-External-User-Id': externalUserData.id,
    'X-External-User-Name': externalUserData.name,
  };

  if (externalUserData.email) {
    headers['X-External-User-Email'] = externalUserData.email;
  }

  return headers;
}

export default state;
